"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapAxeDevtoolsTestRecordIssue = void 0;
const axe_devtools_issues_utils_1 = require("@deque/axe-devtools-issues-utils");
const mapAxeDevtoolsTestRecordIssue = (issue, otherProps) => {
    const igtTool = issue.manifest_guide;
    const igt = issue.manifest_guide ? (0, axe_devtools_issues_utils_1.getIgtName)(igtTool) : null;
    const mappedIssue = {
        ruleId: issue.rule,
        help: issue.help,
        description: issue.description || '',
        helpUrl: issue.help_url,
        impact: issue.impact,
        isExperimental: false,
        isManual: issue.is_manual,
        needsReview: !!issue.needs_review,
        summary: issue.summary,
        tags: issue.tags || [],
        createdAt: issue.created_at,
        issueId: issue.id,
        testName: issue.test_name,
        href: otherProps.href
    };
    if (igt) {
        mappedIssue.igt = igt;
    }
    if (issue.found_by) {
        mappedIssue.foundBy = issue.found_by;
    }
    if (issue.bounding_box) {
        mappedIssue.boundingBox = issue.bounding_box;
    }
    if (issue.screenshot_id) {
        mappedIssue.screenshotId = issue.screenshot_id;
    }
    if (issue.manifest_id) {
        mappedIssue.manifestId = issue.manifest_id;
    }
    if (issue.manifest_guide) {
        mappedIssue.igtId = issue.manifest_guide;
    }
    if (issue.source) {
        mappedIssue.source = issue.source;
    }
    if (issue.remediation) {
        mappedIssue.remediation = issue.remediation;
    }
    if (issue.test_url) {
        mappedIssue.testUrl = issue.test_url;
    }
    if (issue.selector) {
        mappedIssue.selector = issue.selector;
    }
    return {
        ...mappedIssue,
        ...otherProps
    };
};
exports.mapAxeDevtoolsTestRecordIssue = mapAxeDevtoolsTestRecordIssue;
//# sourceMappingURL=mapAxeDevtoolsTestRecordIssue.js.map